/******************************************************************************
 * This file was generated by ZenStack CLI.
 ******************************************************************************/

/* eslint-disable */
// @ts-nocheck

import { z } from 'zod';
const baseSchema = z.object({
    createdAt: z.coerce.date().default(() => new Date()),
    createdById: z.string().optional(),
    updatedAt: z.coerce.date(),
    updatedById: z.string().nullish(),
    deletedAt: z.coerce.date().nullish(),
    deletedById: z.string().nullish(),
    id: z.string(),
    isSaved: z.boolean().default(true),
}
).strict();
const baseSchemaWithoutDefaults = z.object({
    createdAt: z.coerce.date(),
    createdById: z.string().optional(),
    updatedAt: z.coerce.date(),
    updatedById: z.string().nullish(),
    deletedAt: z.coerce.date().nullish(),
    deletedById: z.string().nullish(),
    id: z.string(),
    isSaved: z.boolean(),
}
).strict();
const relationSchema = z.object({
    listing: z.record(z.string(), z.unknown()),
    person: z.record(z.string(), z.unknown()),
}
);
const fkSchema = z.object({
    listingId: z.string(),
    personId: z.string(),
}
);

/**
 * `SavedListing` schema excluding foreign keys and relations.
 */
export const SavedListingScalarSchema = baseSchema;


/**
 * `SavedListing` schema including all fields (scalar, foreign key, and relations) and validations.
 */
export const SavedListingSchema = SavedListingScalarSchema.merge(fkSchema).merge(relationSchema.partial());


/**
 * Schema used for validating Prisma create input. For internal use only.
 * @private
 */
export const SavedListingPrismaCreateSchema = baseSchemaWithoutDefaults.partial().passthrough();


/**
 * Schema used for validating Prisma update input. For internal use only.
 * @private
 */
export const SavedListingPrismaUpdateSchema = z.object({
    createdAt: z.coerce.date(),
    createdById: z.string().optional(),
    updatedAt: z.coerce.date(),
    updatedById: z.string().nullish(),
    deletedAt: z.coerce.date().nullish(),
    deletedById: z.string().nullish(),
    id: z.string(),
    isSaved: z.boolean()
}).partial().passthrough();


/**
 * `SavedListing` schema for create operations excluding foreign keys and relations.
 */
export const SavedListingCreateScalarSchema = baseSchemaWithoutDefaults.partial({
    createdAt: true, createdById: true, updatedAt: true, updatedById: true, id: true, isSaved: true
});


/**
 * `SavedListing` schema for create operations including scalar fields, foreign key fields, and validations.
 */
export const SavedListingCreateSchema = SavedListingCreateScalarSchema.merge(fkSchema);


/**
 * `SavedListing` schema for update operations excluding foreign keys and relations.
 */
export const SavedListingUpdateScalarSchema = baseSchemaWithoutDefaults.partial();


/**
 * `SavedListing` schema for update operations including scalar fields, foreign key fields, and validations.
 */
export const SavedListingUpdateSchema = SavedListingUpdateScalarSchema.merge(fkSchema.partial());

